module.exports = __webpack_public_path__ + "img/gold30.3cc8259c.png";